import axios from 'axios';
import {
    JackpotTypes
} from 'actions/types';

export function fetchJackpotWinners(route, params) {
	return (dispatch, getState) => {
      const host = getState().config.get( 'host' );
      const headers = getState().config.get( 'headers' ).toJSON();
      const href = route.get( 'href' );
      const url = `${host}${href}`
      const method = route.get( 'method' )

		dispatch({
			type: JackpotTypes.FETCH_JACKPOT_WINNERS,
			payload: {
				route,
				method,
				headers,
				params,
				url,
			}
		})

		return axios({
			url,
			method,
			headers,
			params
		})
		.then(response => {
			//dispatch(setTournamentPreview(response.data, params));
			return response.data
		})
		.catch(error => {
			throw error
		})
	}
}

export function setJackpotWinners(data) {
	return (dispatch, getState) => {
		dispatch({
			type: JackpotTypes.SET_JACKPOT_WINNERS,
			payload: {
				data: data
			}
		})
	}
}

export function fetchJackpotDetails(route) {
	return (dispatch, getState) => {
      const host = getState().config.get( 'host' );
      const headers = getState().config.get( 'headers' ).toJSON();
      const href = route.get( 'href' );
      const url = `${host}${href}`
      const method = route.get( 'method' )

		dispatch({
			type: JackpotTypes.FETCH_JACKPOT_DETAILS,
			payload: {
				route: route,
				method: method,
				headers: headers,
				url: url
			}
		})

		return axios({
			url: url,
			method: method,
			headers: headers
		})
		.then(response => {
			//dispatch(setTournamentPreview(response.data, params));
			return response.data
		})
		.catch(error => {
			throw error
		})
	}
}

export function setJackpotDetails(data) {
	return (dispatch, getState) => {
		dispatch({
			type: JackpotTypes.SET_JACKPOT_DETAILS,
			payload: {
				data: data
			}
		})
	}
}